import { render } from "./Zusammenarbeit.vue?vue&type=template&id=1e2878bb&scoped=true"
import script from "./Zusammenarbeit.vue?vue&type=script&lang=ts"
export * from "./Zusammenarbeit.vue?vue&type=script&lang=ts"

import "./Zusammenarbeit.vue?vue&type=style&index=0&id=1e2878bb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e2878bb"

export default script